import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRilomaAppIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 42,
			height: 42,
			rx: 12,
			fill: "url(#paint0_linear_6205_806)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2032 23.1219C15.814 23.1219 15.4897 22.9922 15.214 22.7165C14.9383 22.4408 14.8086 22.1165 14.8086 21.7273C14.8086 21.3381 14.9383 21.0137 15.214 20.738C15.4897 20.4624 15.814 20.3164 16.2032 20.3164C16.5924 20.3164 16.933 20.4624 17.2087 20.738C17.4844 21.0137 17.6303 21.3381 17.6303 21.7273C17.6303 22.1165 17.4844 22.4408 17.2087 22.7165C16.933 22.976 16.5924 23.1219 16.2032 23.1219Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3438 9.15039C32.2208 9.19093 33.7275 10.7741 33.7275 12.6631V30.582C33.7275 31.2122 33.5107 31.733 33.0869 32.1729C32.6474 32.6124 32.1272 32.8301 31.4961 32.8301C30.8643 32.83 30.3464 32.6119 29.9248 32.1758C29.502 31.7384 29.2979 31.218 29.2979 30.582V20.6094L29.3135 16.1016C29.3137 16.0379 29.2894 15.9771 29.2461 15.9307C29.0738 15.4268 28.5196 15.1411 27.998 15.3496L27.9785 15.3584C27.9471 15.3741 27.9232 15.3904 27.9111 15.3984C27.8993 15.4063 27.8983 15.4058 27.8975 15.4062L27.8867 15.4131L27.5146 15.623C26.8115 16.0178 26.1465 16.4584 25.4951 16.9141L24.8477 17.373C24.4597 17.6523 24.0385 17.8873 23.583 18.0918C22.8025 18.4196 21.9759 18.5918 21.1016 18.5918H21.0088C20.1652 18.5762 19.3678 18.404 18.6006 18.0908C18.1525 17.9052 17.7319 17.656 17.3389 17.373H17.3379C16.4957 16.7576 15.6263 16.1339 14.6885 15.6074V15.6064L14.2822 15.3799H14.2812C14.1939 15.3271 14.0942 15.3035 14.0439 15.291H14.0449C13.5391 15.1592 13.0132 15.4656 12.8809 15.9727L12.8799 15.9756C12.8666 16.0285 12.8398 16.1118 12.8398 16.2305V21.3223C12.8398 21.3346 12.841 21.3472 12.8428 21.3594C12.9303 21.9426 13.0692 22.5041 13.2832 23.0527L13.3799 23.2871C13.7955 24.2511 14.3463 25.1033 15.0498 25.8242V25.8252C15.7541 26.563 16.5909 27.1481 17.54 27.5977C18.4947 28.0498 19.5028 28.3016 20.5947 28.3184H20.793C21.41 28.3184 21.9153 28.5209 22.3545 28.9453C22.7926 29.3688 23.0566 29.9858 23.0566 30.5986C23.0566 31.1994 22.8545 31.7032 22.4326 32.125C22.005 32.5525 21.4936 32.7858 20.8887 32.8301H20.5566C18.8538 32.7823 17.2493 32.4161 15.7568 31.7334H15.7559C14.8488 31.3196 14.0063 30.8099 13.2432 30.2217L13.2402 30.2197L13.1045 30.1133C13.0972 30.1061 13.0891 30.0991 13.0811 30.0928C12.6545 29.761 12.2416 29.3806 11.8594 28.9824L11.8584 28.9805C10.8845 27.9787 10.093 26.8428 9.47266 25.5605L9.2168 25.002C8.81372 24.0566 8.53285 23.0756 8.38379 22.0586L8.32812 21.6201C8.28016 21.1401 8.24806 20.6468 8.24805 20.1553V12.6631L8.25195 12.4883C8.33897 10.7065 9.75173 9.23484 11.5391 9.15137C12.2414 9.23014 12.9143 9.45879 13.5273 9.82617V9.82715L17.0791 12V12.001C19.4777 13.4602 22.5135 13.4597 24.9131 11.9668L24.9141 11.9678L28.043 10.0371L28.0439 10.0381L28.0498 10.0332C28.7278 9.58635 29.5129 9.27674 30.3438 9.15039Z",
			fill: "black",
			stroke: "url(#paint1_linear_6205_806)",
			strokeWidth: .5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2789 20.7382C18.2951 20.6409 18.2789 20.5598 18.2627 20.4787C18.2464 20.3976 18.2302 20.3166 18.214 20.2193C18.1654 20.0571 18.1005 19.8949 18.0032 19.7328C17.9059 19.5706 17.7762 19.4246 17.6464 19.3273C17.5167 19.2138 17.3383 19.1165 17.1599 19.0516C16.8356 18.9381 16.4626 18.9057 16.1058 18.9706C15.9274 19.003 15.7491 19.0516 15.6031 19.1327C15.5058 19.1814 15.4409 19.2138 15.3761 19.2625C15.3112 19.3111 15.2301 19.376 15.1815 19.4571L15.1328 19.5544L15.2301 19.5057C15.3598 19.4408 15.4896 19.4408 15.6355 19.4246H15.6842C15.8301 19.4084 15.9761 19.4084 16.1383 19.4246C16.4626 19.4408 16.7383 19.4895 16.9815 19.5706C17.1113 19.6192 17.2248 19.6679 17.3383 19.749C17.4518 19.8301 17.5653 19.9274 17.6626 20.0247C17.7599 20.122 17.8572 20.2355 17.9545 20.3652C18.0356 20.4787 18.1329 20.6085 18.214 20.7706L18.2627 20.8679L18.2789 20.7382Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_6205_806",
			x1: 2.60449,
			y1: 2.17383,
			x2: 39.5391,
			y2: 39.8262,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9CFF00" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#79BF0A"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_6205_806",
			x1: 9.7254,
			y1: 8.90039,
			x2: 33.0447,
			y2: 33.0833,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "white",
					stopOpacity: .5
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})
			]
		})] })
	]
});
export default SvgRilomaAppIcon;
